import * as yup from 'yup';

export const validationSchema = yup.object({
  email: yup.string().email('Enter a valid email'),
  feedback: yup.string().required('Feedback message is required'),
});
